const colors = {
  "--colors-white": "#FFFFFF",
  "--colors-black": "#000000",
  "--colors-brand-25": "#FCFAFF",
  "--colors-brand-50": "#F9F5FF",
  "--colors-brand-100": "#F4EBFF",
  "--colors-brand-200": "#E9D7FE",
  "--colors-brand-300": "#D6BBFB",
  "--colors-brand-400": "#B692F6",
  "--colors-brand-500": "#9E77ED",
  "--colors-brand-600": "#7F56D9",
  "--colors-brand-700": "#6941C6",
  "--colors-brand-800": "#53389E",
  "--colors-brand-900": "#42307D",
  "--colors-brand-950": "#2C1C5F",
  "--colors-error-25": "#FFFBFA",
  "--colors-error-50": "#FEF3F2",
  "--colors-error-100": "#FEE4E2",
  "--colors-error-200": "#FECDCA",
  "--colors-error-300": "#FDA29B",
  "--colors-error-400": "#F97066",
  "--colors-error-500": "#F04438",
  "--colors-error-600": "#D92D20",
  "--colors-error-700": "#B42318",
  "--colors-error-800": "#912018",
  "--colors-error-900": "#7A271A",
  "--colors-error-950": "#55160C",
  "--colors-warning-25": "#FFFCF5",
  "--colors-warning-50": "#FFFAEB",
  "--colors-warning-100": "#FEF0C7",
  "--colors-warning-200": "#FEDF89",
  "--colors-warning-300": "#FEC84B",
  "--colors-warning-400": "#FDB022",
  "--colors-warning-500": "#F79009",
  "--colors-warning-600": "#DC6803",
  "--colors-warning-700": "#B54708",
  "--colors-warning-800": "#93370D",
  "--colors-warning-900": "#7A2E0E",
  "--colors-warning-950": "#4E1D09",
  "--colors-success-25": "#F6FEF9",
  "--colors-success-50": "#ECFDF3",
  "--colors-success-100": "#DCFAE6",
  "--colors-success-200": "#ABEFC6",
  "--colors-success-300": "#75E0A7",
  "--colors-success-400": "#47CD89",
  "--colors-success-500": "#17B26A",
  "--colors-success-600": "#079455",
  "--colors-success-700": "#067647",
  "--colors-success-800": "#085D3A",
  "--colors-success-900": "#074D31",
  "--colors-success-950": "#053321",
  "--colors-gray-light-25": "#FCFCFD",
  "--colors-gray-light-50": "#F9FAFB",
  "--colors-gray-light-100": "#F2F4F7",
  "--colors-gray-light-200": "#EAECF0",
  "--colors-gray-light-300": "#D0D5DD",
  "--colors-gray-light-400": "#98A2B3",
  "--colors-gray-light-500": "#667085",
  "--colors-gray-light-600": "#475467",
  "--colors-gray-light-700": "#344054",
  "--colors-gray-light-800": "#182230",
  "--colors-gray-light-900": "#101828",
  "--colors-gray-light-950": "#0C111D",
  "--colors-gray-dark-25": "#FAFAFA",
  "--colors-gray-dark-50": "#F5F5F6",
  "--colors-gray-dark-100": "#F0F1F1",
  "--colors-gray-dark-200": "#ECECED",
  "--colors-gray-dark-300": "#CECFD2",
  "--colors-gray-dark-400": "#94969C",
  "--colors-gray-dark-500": "#85888E",
  "--colors-gray-dark-600": "#61646C",
  "--colors-gray-dark-700": "#333741",
  "--colors-gray-dark-800": "#1F242F",
  "--colors-gray-dark-900": "#161B26",
  "--colors-gray-dark-950": "#0C111D",
  "--colors-gray-blue-25": "#FCFCFD",
  "--colors-gray-blue-50": "#F8F9FC",
  "--colors-gray-blue-100": "#EAECF5",
  "--colors-gray-blue-200": "#D5D9EB",
  "--colors-gray-blue-300": "#B3B8DB",
  "--colors-gray-blue-400": "#717BBC",
  "--colors-gray-blue-500": "#4E5BA6",
  "--colors-gray-blue-600": "#3E4784",
  "--colors-gray-blue-700": "#363F72",
  "--colors-gray-blue-800": "#293056",
  "--colors-gray-blue-900": "#101323",
  "--colors-gray-blue-950": "#0D0F1C",
  "--colors-gray-cool-25": "#FCFCFD",
  "--colors-gray-cool-50": "#F9F9FB",
  "--colors-gray-cool-100": "#EFF1F5",
  "--colors-gray-cool-200": "#DCDFEA",
  "--colors-gray-cool-300": "#B9C0D4",
  "--colors-gray-cool-400": "#7D89B0",
  "--colors-gray-cool-500": "#5D6B98",
  "--colors-gray-cool-600": "#4A5578",
  "--colors-gray-cool-700": "#404968",
  "--colors-gray-cool-800": "#30374F",
  "--colors-gray-cool-900": "#111322",
  "--colors-gray-cool-950": "#0E101B",
  "--colors-gray-modern-25": "#FCFCFD",
  "--colors-gray-modern-50": "#F8FAFC",
  "--colors-gray-modern-100": "#EEF2F6",
  "--colors-gray-modern-200": "#E3E8EF",
  "--colors-gray-modern-300": "#CDD5DF",
  "--colors-gray-modern-400": "#9AA4B2",
  "--colors-gray-modern-500": "#697586",
  "--colors-gray-modern-600": "#4B5565",
  "--colors-gray-modern-700": "#364152",
  "--colors-gray-modern-800": "#202939",
  "--colors-gray-modern-900": "#121926",
  "--colors-gray-modern-950": "#0D121C",
  "--colors-gray-iron-25": "#FCFCFC",
  "--colors-gray-iron-50": "#FAFAFA",
  "--colors-gray-iron-100": "#F4F4F5",
  "--colors-gray-iron-200": "#E4E4E7",
  "--colors-gray-iron-300": "#D1D1D6",
  "--colors-gray-iron-400": "#A0A0AB",
  "--colors-gray-iron-500": "#70707B",
  "--colors-gray-iron-600": "#51525C",
  "--colors-gray-iron-700": "#3F3F46",
  "--colors-gray-iron-800": "#26272B",
  "--colors-gray-iron-900": "#1A1A1E",
  "--colors-gray-iron-950": "#131316",
  "--colors-gray-true-25": "#FCFCFC",
  "--colors-gray-true-50": "#FAFAFA",
  "--colors-gray-true-100": "#F5F5F5",
  "--colors-gray-true-200": "#E5E5E5",
  "--colors-gray-true-300": "#D6D6D6",
  "--colors-gray-true-400": "#A3A3A3",
  "--colors-gray-true-500": "#737373",
  "--colors-gray-true-600": "#525252",
  "--colors-gray-true-700": "#424242",
  "--colors-gray-true-800": "#292929",
  "--colors-gray-true-900": "#141414",
  "--colors-gray-true-950": "#0F0F0F",
  "--colors-gray-warm-25": "#FDFDFC",
  "--colors-gray-warm-50": "#FAFAF9",
  "--colors-gray-warm-100": "#F5F5F4",
  "--colors-gray-warm-200": "#E7E5E4",
  "--colors-gray-warm-300": "#D7D3D0",
  "--colors-gray-warm-400": "#A9A29D",
  "--colors-gray-warm-500": "#79716B",
  "--colors-gray-warm-600": "#57534E",
  "--colors-gray-warm-700": "#44403C",
  "--colors-gray-warm-800": "#292524",
  "--colors-gray-warm-900": "#1C1917",
  "--colors-gray-warm-950": "#171412",
  "--colors-moss-25": "#FAFDF7",
  "--colors-moss-50": "#F5FBEE",
  "--colors-moss-100": "#E6F4D7",
  "--colors-moss-200": "#CEEAB0",
  "--colors-moss-300": "#ACDC79",
  "--colors-moss-400": "#86CB3C",
  "--colors-moss-500": "#669F2A",
  "--colors-moss-600": "#4F7A21",
  "--colors-moss-700": "#3F621A",
  "--colors-moss-800": "#335015",
  "--colors-moss-900": "#2B4212",
  "--colors-moss-950": "#1A280B",
  "--colors-green-25": "#F6FEF9",
  "--colors-green-50": "#EDFCF2",
  "--colors-green-100": "#D3F8DF",
  "--colors-green-200": "#AAF0C4",
  "--colors-green-300": "#73E2A3",
  "--colors-green-400": "#3CCB7F",
  "--colors-green-500": "#16B364",
  "--colors-green-600": "#099250",
  "--colors-green-700": "#087443",
  "--colors-green-800": "#095C37",
  "--colors-green-900": "#084C2E",
  "--colors-green-950": "#052E1C",
  "--colors-green-light-25": "#FAFEF5",
  "--colors-green-light-50": "#F3FEE7",
  "--colors-green-light-100": "#E4FBCC",
  "--colors-green-light-200": "#D0F8AB",
  "--colors-green-light-300": "#A6EF67",
  "--colors-green-light-400": "#85E13A",
  "--colors-green-light-500": "#66C61C",
  "--colors-green-light-600": "#4CA30D",
  "--colors-green-light-700": "#3B7C0F",
  "--colors-green-light-800": "#326212",
  "--colors-green-light-900": "#2B5314",
  "--colors-green-light-950": "#15290A",
  "--colors-teal-25": "#F6FEFC",
  "--colors-teal-50": "#F0FDF9",
  "--colors-teal-100": "#CCFBEF",
  "--colors-teal-200": "#99F6E0",
  "--colors-teal-300": "#5FE9D0",
  "--colors-teal-400": "#2ED3B7",
  "--colors-teal-500": "#15B79E",
  "--colors-teal-600": "#0E9384",
  "--colors-teal-700": "#107569",
  "--colors-teal-800": "#125D56",
  "--colors-teal-900": "#134E48",
  "--colors-teal-950": "#0A2926",
  "--colors-cyan-25": "#F5FEFF",
  "--colors-cyan-50": "#ECFDFF",
  "--colors-cyan-100": "#CFF9FE",
  "--colors-cyan-200": "#A5F0FC",
  "--colors-cyan-300": "#67E3F9",
  "--colors-cyan-400": "#22CCEE",
  "--colors-cyan-500": "#06AED4",
  "--colors-cyan-600": "#088AB2",
  "--colors-cyan-700": "#0E7090",
  "--colors-cyan-800": "#155B75",
  "--colors-cyan-900": "#164C63",
  "--colors-cyan-950": "#0D2D3A",
  "--colors-blue-25": "#F5FAFF",
  "--colors-blue-50": "#EFF8FF",
  "--colors-blue-100": "#D1E9FF",
  "--colors-blue-200": "#B2DDFF",
  "--colors-blue-300": "#84CAFF",
  "--colors-blue-400": "#53B1FD",
  "--colors-blue-500": "#2E90FA",
  "--colors-blue-600": "#1570EF",
  "--colors-blue-700": "#175CD3",
  "--colors-blue-800": "#1849A9",
  "--colors-blue-900": "#194185",
  "--colors-blue-950": "#102A56",
  "--colors-blue-light-25": "#F5FBFF",
  "--colors-blue-light-50": "#F0F9FF",
  "--colors-blue-light-100": "#E0F2FE",
  "--colors-blue-light-200": "#B9E6FE",
  "--colors-blue-light-300": "#7CD4FD",
  "--colors-blue-light-400": "#36BFFA",
  "--colors-blue-light-500": "#0BA5EC",
  "--colors-blue-light-600": "#0086C9",
  "--colors-blue-light-700": "#026AA2",
  "--colors-blue-light-800": "#065986",
  "--colors-blue-light-900": "#0B4A6F",
  "--colors-blue-light-950": "#062C41",
  "--colors-blue-dark-25": "#F5F8FF",
  "--colors-blue-dark-50": "#EFF4FF",
  "--colors-blue-dark-100": "#D1E0FF",
  "--colors-blue-dark-200": "#B2CCFF",
  "--colors-blue-dark-300": "#84ADFF",
  "--colors-blue-dark-400": "#528BFF",
  "--colors-blue-dark-500": "#2970FF",
  "--colors-blue-dark-600": "#155EEF",
  "--colors-blue-dark-700": "#004EEB",
  "--colors-blue-dark-800": "#0040C1",
  "--colors-blue-dark-900": "#00359E",
  "--colors-blue-dark-950": "#002266",
  "--colors-indigo-25": "#F5F8FF",
  "--colors-indigo-50": "#EEF4FF",
  "--colors-indigo-100": "#E0EAFF",
  "--colors-indigo-200": "#C7D7FE",
  "--colors-indigo-300": "#A4BCFD",
  "--colors-indigo-400": "#8098F9",
  "--colors-indigo-500": "#6172F3",
  "--colors-indigo-600": "#444CE7",
  "--colors-indigo-700": "#3538CD",
  "--colors-indigo-800": "#2D31A6",
  "--colors-indigo-900": "#2D3282",
  "--colors-indigo-950": "#1F235B",
  "--colors-violet-25": "#FBFAFF",
  "--colors-violet-50": "#F5F3FF",
  "--colors-violet-100": "#ECE9FE",
  "--colors-violet-200": "#DDD6FE",
  "--colors-violet-300": "#C3B5FD",
  "--colors-violet-400": "#A48AFB",
  "--colors-violet-500": "#875BF7",
  "--colors-violet-600": "#7839EE",
  "--colors-violet-700": "#6927DA",
  "--colors-violet-800": "#5720B7",
  "--colors-violet-900": "#491C96",
  "--colors-violet-950": "#2E125E",
  "--colors-purple-25": "#FAFAFF",
  "--colors-purple-50": "#F4F3FF",
  "--colors-purple-100": "#EBE9FE",
  "--colors-purple-200": "#D9D6FE",
  "--colors-purple-300": "#BDB4FE",
  "--colors-purple-400": "#9B8AFB",
  "--colors-purple-500": "#7A5AF8",
  "--colors-purple-600": "#6938EF",
  "--colors-purple-700": "#5925DC",
  "--colors-purple-800": "#4A1FB8",
  "--colors-purple-900": "#3E1C96",
  "--colors-purple-950": "#27115F",
  "--colors-fuchsia-25": "#FEFAFF",
  "--colors-fuchsia-50": "#FDF4FF",
  "--colors-fuchsia-100": "#FBE8FF",
  "--colors-fuchsia-200": "#F6D0FE",
  "--colors-fuchsia-300": "#EEAAFD",
  "--colors-fuchsia-400": "#E478FA",
  "--colors-fuchsia-500": "#D444F1",
  "--colors-fuchsia-600": "#BA24D5",
  "--colors-fuchsia-700": "#9F1AB1",
  "--colors-fuchsia-800": "#821890",
  "--colors-fuchsia-900": "#6F1877",
  "--colors-fuchsia-950": "#47104C",
  "--colors-pink-25": "#FEF6FB",
  "--colors-pink-50": "#FDF2FA",
  "--colors-pink-100": "#FCE7F6",
  "--colors-pink-200": "#FCCEEE",
  "--colors-pink-300": "#FAA7E0",
  "--colors-pink-400": "#F670C7",
  "--colors-pink-500": "#EE46BC",
  "--colors-pink-600": "#DD2590",
  "--colors-pink-700": "#C11574",
  "--colors-pink-800": "#9E165F",
  "--colors-pink-900": "#851651",
  "--colors-pink-950": "#4E0D30",
  "--colors-rose-25": "#FFF5F6",
  "--colors-rose-50": "#FFF1F3",
  "--colors-rose-100": "#FFE4E8",
  "--colors-rose-200": "#FECDD6",
  "--colors-rose-300": "#FEA3B4",
  "--colors-rose-400": "#FD6F8E",
  "--colors-rose-500": "#F63D68",
  "--colors-rose-600": "#E31B54",
  "--colors-rose-700": "#C01048",
  "--colors-rose-800": "#A11043",
  "--colors-rose-900": "#89123E",
  "--colors-rose-950": "#510B24",
  "--colors-orange-25": "#FEFAF5",
  "--colors-orange-50": "#FEF6EE",
  "--colors-orange-100": "#FDEAD7",
  "--colors-orange-200": "#F9DBAF",
  "--colors-orange-300": "#F7B27A",
  "--colors-orange-400": "#F38744",
  "--colors-orange-500": "#EF6820",
  "--colors-orange-600": "#E04F16",
  "--colors-orange-700": "#B93815",
  "--colors-orange-800": "#932F19",
  "--colors-orange-900": "#772917",
  "--colors-orange-950": "#511C10",
  "--colors-orange-dark-25": "#FFF9F5",
  "--colors-orange-dark-50": "#FFF4ED",
  "--colors-orange-dark-100": "#FFE6D5",
  "--colors-orange-dark-200": "#FFD6AE",
  "--colors-orange-dark-300": "#FF9C66",
  "--colors-orange-dark-400": "#FF692E",
  "--colors-orange-dark-500": "#FF4405",
  "--colors-orange-dark-600": "#E62E05",
  "--colors-orange-dark-700": "#BC1B06",
  "--colors-orange-dark-800": "#97180C",
  "--colors-orange-dark-900": "#771A0D",
  "--colors-orange-dark-950": "#57130A",
  "--colors-yellow-25": "#FEFDF0",
  "--colors-yellow-50": "#FEFBE8",
  "--colors-yellow-100": "#FEF7C3",
  "--colors-yellow-200": "#FEEE95",
  "--colors-yellow-300": "#FDE272",
  "--colors-yellow-400": "#FAC515",
  "--colors-yellow-500": "#EAAA08",
  "--colors-yellow-600": "#CA8504",
  "--colors-yellow-700": "#A15C07",
  "--colors-yellow-800": "#854A0E",
  "--colors-yellow-900": "#713B12",
  "--colors-yellow-950": "#542C0D",
  "--colors-transparent": "transparent"
};
export default colors;